import axios from 'axios';
import { apiConfig } from '../config';

import {
  isValidToken,
  refreshAuthToken,
  setSession
} from '../redux/slices/authJwt';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: apiConfig.endpoint });

axiosInstance.interceptors.request.use(
  async (request) => {
    if (request.headers && request.headers.Authorization) {
      if (!isValidToken(request.headers.Authorization)) {
        // If not refresh token query
        if (!(request.data.query.indexOf('refreshToken') > -1)) {
          const response = await refreshAuthToken();
          await setSession(response.data.data.refreshToken.AccessToken);
          request.headers.Authorization = `Bearer ${response.data.data.refreshToken.AccessToken}`;
          // window.location.reload();
        }
      }
    }
    return request;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.error(error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
